<template>
  <nav class="navbar has-shadow fade-in">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img :src="practice.logo" alt="Logo" class="logo" />
      </a>
      <div class="name mt2 ml2">{{ practice.name }}</div>

      <div class="navbar-burger is-hidden-desktop" @click="navToggle">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="navbar-menu is-active" v-if="isAuth">
      <div class="navbar-end">
        <router-link :to="{ name: 'help' }" class="navbar-item"
          >Help & Support</router-link
        >
        <div class="navbar-item has-dropdown is-hoverable">
          <a href="#" class="navbar-link"
            >{{ user.firstName }} {{ user.lastName }}</a
          >
          <div class="navbar-dropdown">
            <a
              class="navbar-item"
              href="#"
              v-on:click.prevent="showPracticeSwitcher()"
              v-if="hasManyPractices()"
              >Change Account</a
            >

            <router-link :to="{ name: 'user-profile' }" class="navbar-item"
              >Your Profile</router-link
            >

            <hr class="dropdown-divider" />

            <router-link
              :to="{ name: 'settings-index' }"
              class="navbar-item"
              v-if="$can('interview:update|interview:manage')"
              >Account Settings</router-link
            >

            <hr class="dropdown-divider" />

            <router-link
              :to="{ name: 'symptom-list' }"
              class="navbar-item"
              v-if="$can('symptom:read|symptom:manage')"
              >ROS Admin</router-link
            >

            <hr class="dropdown-divider" />

            <a class="navbar-item" href="#" v-on:click="onLogout">Log Out</a>
          </div>
        </div>
      </div>
    </div>
    <practice-switcher></practice-switcher>
  </nav>
</template>

<script>
import AuthService from "@/services/AuthService";
import PracticeSwitcher from "@/components/PracticeSwitcher";

export default {
  name: "navigation",

  components: {
    PracticeSwitcher
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    isAuth() {
      return this.$store.state.isAuth;
    },

    practice() {
      return this.$store.getters["practice/current"];
    }
  },

  methods: {
    hasManyPractices() {
      return Object.keys(this.practice).length > 1;
    },
    onLogout() {
      AuthService.logout()
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(data => {
          this.$refs.toastr.e("Sorry, something went wrong. Please try again.");
        });
    },
    showPracticeSwitcher() {
      this.$store.dispatch("practice/toggleSwitcher", true);
    },
    navToggle() {
      this.$store.dispatch("navToggle");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.logo {
  max-height: 50px;
}
</style>
